import React from 'react'
import { Outlet } from "react-router-dom";
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';

const DashboardLayout = ({ children }) => {
    return (
        <>
            <div className='w-full flex fixed h-screen'>
                <div className='w-full overflow-y-scroll flex-col px-6 mt-5'>
                    <Navbar />
                    {/* Sidebar drawer — toggled by the top-left hamburger in Navbar */}
                    <Sidebar />
                    <Outlet>
                        {children}
                    </Outlet>
                </div>
            </div>
        </>
    )
}

export default DashboardLayout
